<template>
  <div class="main">
    <Sidebar
      :current-keywords="keywords"
      :current-filters="currentFilters"
      :filter-types="filterTypes"
      @search="setKeywords"
      @add-filter="addFilter"
      @remove-filter="removeFilter"
      @remove-all-filters="removeAllFilters"
    />

    <div class="title-bar">
      <a
        class="float-right btn btn-secondary"
        :href="route('admin.courses.create')"
      >
        <span class="icon icon-plus"></span>
        <span class="text">Add New</span>
      </a>
      <h1>Courses</h1>
      <AdminMenu class="pt-2" current="Training" />
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>
          <div class="row">
            <div
              :class="{
                'col-12': !showDetailsPane,
                'col-8 details-pane-open': showDetailsPane,
              }"
            >
              <ListTable
                :items="items"
                :columns="columns"
                :activeColumns="activeColumns"
                :hideNoResults="hideNoResults"
                :hasDetailsPane="showDetailsPane"
                @sort-by="setSort"
                @swap-column="setActiveColumn"
                @item-clicked="setSelectedItem"
              >
                <template v-slot:col_type="{ item }">{{
                  item.type_label
                }}</template>
                <template v-slot:col_cost="{ item }">{{
                  item.enrollment_cost | cost
                }}</template>
                  <template v-slot:col_distributor_cost="{ item }">{{
                      item.distributor_cost | cost
                  }}</template>
                <template v-slot:col_distributor_billing_fee="{ item }">{{
                  item.distributor_billing_fee | cost
                }}</template>
                <template v-slot:col_created_at="{ item }">{{
                  item.created_at | moment("MM/DD/YYYY")
                }}</template>
                <template v-slot:col_updated_at="{ item }">{{
                  item.updated_at | moment("MM/DD/YYYY")
                }}</template>
                <template v-slot:list-menu="{ item, id }">
                  <ListMenu :item="item" :id="id" :eventBus="listEvents" />
                </template>
              </ListTable>
            </div>
            <div v-if="showDetailsPane" class="col-4 details-pane-wrap mb-3">
              <DetailsPane
                :course="selectedItem"
                :tab="selectedTab"
                @close="setSelectedItem(null)"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xl-3">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-xl-6 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-3 text-center text-xl-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import AdminMenu from "../partials/AdminMenu";
import ListMenu from "./partials/CourseListMenu";
import DetailsPane from "components/partials/Courses/DetailsPane";

export default {
  mixins: [DisplaysAlerts, ListingMixin],
  components: {
    AdminMenu,
    ListMenu,
    DetailsPane,
  },
  methods: {
    delete(item) {
      if (confirm(`Are you sure you would like to remove: "${item.name}"?`)) {
        this.axios
          .delete(this.route("admin.courses.destroy", { course: item.id }))
          .then(() => {
            this.refresh();
            this.showAlert("success", `"${item.name}" has been removed`, true);
          });
      }
    },
    clone(item) {
      this.goToRoute("admin.courses.clone", { course: item.id });
    },
    activate(item) {
      this.axios
        .post(this.route("admin.courses.activate", { course: item.id }))
        .then(() => {
          this.showAlert("success", `"${item.name}" has been ACTIVATED.`, true);
          this.refresh();
        })
        .catch(() => {});
    },
    deactivate(item) {
      this.axios
        .post(this.route("admin.courses.deactivate", { course: item.id }))
        .then(() => {
          this.showAlert(
            "success",
            `"${item.name}" has been DE-ACTIVATED.`,
            true
          );
          this.refresh();
        })
        .catch(() => {});
    },
    handleMenuAction(action, item) {
      if (action === "remove") {
        this.delete(item);
      } else if (action === "clone") {
        this.clone(item);
      } else if (action === "activate") {
        this.activate(item);
      } else if (action === "deactivate") {
        this.deactivate(item);
      }
    },
  },
  mounted() {
    this.listEvents.$on("menu-action", this.handleMenuAction);
    this.listEvents.$on("show-details-pane", this.setSelectedItem);
  },
};
</script>
